var map = {
	"./american-express.png": 514,
	"./discover.png": 515,
	"./jcb.png": 516,
	"./mastercard.png": 517,
	"./savvas-logo.jpg": 1653,
	"./visa.png": 518,
	"./wr-favicon-white.png": 519,
	"./wr-logo-white.png": 223,
	"./wr-logo.png": 520
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;



//////////////////
// WEBPACK FOOTER
// ./assets/images/logos .\.jpg*|.\.png*
// module id = 691
// module chunks = 0